import axios from "axios";
import { toastMessage } from "../utils/toastMessage";

// const API_BASE_URL = "https://gut-buddy-api.applore.in";
const API_BASE_URL = "https://api.gut-buddy.com";
// const API_BASE_URL = "http://localhost:9000";
// const API_BASE_URL = "http://localhost:10009";

let token = localStorage.getItem("token");

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const handleRequestError = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      toastMessage("Your session is expired. Please sign in again", "error");
      localStorage.removeItem("token");
      window.location.replace("/login");
    }

    // Extract message from error response
    let errorMessage = "An error occurred";
    if (error.response.data) {
      if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      } else if (error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.response.data.error) {
        errorMessage = error.response.data.error;
      } else {
        errorMessage = JSON.stringify(error.response.data);
      }
    }

    let err = {
      errorType: "HTTP Error",
      status: error.response.status,
      message: errorMessage,
      response: "Failure",
    };
    return err;
  } else if (error.request) {
    let err = {
      errorType: "Network Error",
      message: error.message || "Network error occurred",
      response: "Failure",
    };
    return err;
  } else {
    // Handle other errors
    console.error("Error:", error.message);
    let err = {
      errorType: "Other Error",
      message: error.message || "An unexpected error occurred",
      response: "Failure",
    };
    return err; // Ensure we return the error object
  }
};

// GET request function
export const get = async (url, params = {}) => {
  try {
    const response = await axiosInstance.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("GET Request Error:", url, error);
    return handleRequestError(error);
  }
};

// POST request function
export const post = async (url, data = {}) => {
  try {
    console.log("🌐 POST Request:", url);
    console.log("📤 POST Data:", JSON.stringify(data, null, 2));

    const response = await axiosInstance.post(url, data);

    console.log("📥 POST Response Status:", response.status);
    console.log("📥 POST Response Data:", JSON.stringify(response.data, null, 2));

    return { data: response.data, response: "Success" };
  } catch (error) {
    console.log("❌ POST Error:", url);
    console.log("❌ POST Error Details:", error);
    return handleRequestError(error);
  }
};

// PUT request function
export const put = async (url, data = {}) => {
  try {
    const response = await axiosInstance.put(url, data);
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

// PATCH request function
export const patch = async (url, data = {}) => {
  try {
    const response = await axiosInstance.patch(url, data);
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

// DELETE request function
export const del = async (url, config = {}) => {
  try {
    const response = await axiosInstance.delete(url, config);
    return response.data;
  } catch (error) {
    return handleRequestError(error);
  }
};

// POST with files
export const postFiles = async (url, data, method) => {
  method = method ? method : "POST";
  try {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: method,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: data,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();
    return { data: responseData, response: "Success" };
  } catch (error) {
    return handleRequestError(error);
  }
};
